module.exports = __webpack_public_path__ + "static/img/feedback.ddbc653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/feedback.png
// module id = jO7p
// module chunks = 1